'use strict';

if ( !Array.prototype.findIndex ) {
    Array.prototype.findIndex = function ( callback ) {
        var size = this.length,
            index = 0;

        while ( index < size ) {
            if ( callback(this[index], index, this) ) {
                return index;
            }

            ++index;
        }

        return -1;
    };
}
